import { Label } from 'reactstrap';
import '../assets/style/SearchBox.css';
import React from 'react';
import moment from 'moment';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
interface IKDatePickerProps {
  label?: string;
  value?: Date;
  minDate?: Date;
  maxDate?: Date;
  onChange: (date: Date) => void;
  yearMonth?: boolean;
  format?: string;
}

const KDatePicker: React.FunctionComponent<IKDatePickerProps> = ({
  label,
  value,
  minDate,
  maxDate,
  onChange,
  yearMonth,
  format,
}) => {
  return (
    <div className="mb-3">
      <Label className="mb-1 text-start search-label">{label}</Label>
      <LocalizationProvider dateAdapter={AdapterMoment}>
        <DemoContainer components={['DatePicker']}>
          <DatePicker
            views={yearMonth ? ['year', 'month'] : undefined}
            minDate={minDate ? moment(minDate) : undefined}
            maxDate={maxDate ? moment(maxDate) : undefined}
            className="date-picker"
            value={value ? moment(value, format ?? 'DD-MM-YYYY') : null}
            format={format ?? 'DD-MM-YYYY'}
            onChange={(newValue) => {
              onChange(newValue ? newValue.toDate() : moment().toDate());
            }}
            sx={{
              '& .MuiOutlinedInput-root': {
                '& fieldset': {
                  border: 'none',
                  borderColor: 'transparent',
                  borderRadius: '0px !important',
                },
                '&:hover fieldset': {
                  borderRadius: '5px !important',
                  border: '1px solid transparent !important',
                },
                '&.Mui-focused fieldset': {
                  borderRadius: '5px !important',
                  border: '1px solid #0b67c3 !important',
                },
              },
            }}
          ></DatePicker>
        </DemoContainer>
      </LocalizationProvider>
    </div>
  );
};

export default KDatePicker;
